// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"351":"02344528","952":"c7908757"}[chunkId] + ".chunk.css";
};